import { Fetch } from 'lib';
import type { SpecialOfferSummary } from 'types';

type RequestResponses = {
  total: number;
  data: SpecialOfferSummary[];
};

type RequestParameters = {
  searchKey: string;
  pageSize: number;
  pageNumber: number;
};

const searchSpecialOffers = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminSpecialOffer/searchSpecialOffers',
    params,
  });

export { searchSpecialOffers };
